import React from 'react';

import Accordion from 'components/Accordion/Accordion';
import ContactOfficeCard from 'components/ContactOfficeCard/ContactOfficeCard';
import Text from 'components/Text/Text';
import ThreeRowsLayout from 'components/ThreeRowsLayout/ThreeRowsLayout';
import { ContactPageDataCMS } from 'containers/ContactPage/ContactPage.types';
import { OfficeCMS } from 'utils/sharedStrapiQueries/sharedTypes';
import { FontNames } from 'utils/styles/theme';

import * as S from './MobileOfficesAccordion.styles';

export type MobileOfficesAccordionProps = {
  emailTile: ContactPageDataCMS['contactOfficeCards']['emailTile'];
  offices: {
    order: number;
    office: OfficeCMS;
  }[];
};

const defaultProps: Partial<MobileOfficesAccordionProps> = {
  emailTile: [],
  offices: [],
};

const MobileOfficesAccordion: React.FunctionComponent<
  MobileOfficesAccordionProps
> = ({ emailTile, offices, ...rest }) => {
  const topContent = (
    <S.TopContent>
      {emailTile.map(({ id, title, email }) => (
        <ThreeRowsLayout
          key={id}
          leftSideContent={
            <Text
              size="smallBody"
              text={title}
              fontFamily={FontNames.sequelSansVFB1}
            />
          }
          rightSideContent={
            <Text
              as="a"
              size="smallBody"
              href={`mailto:${email}`}
              text={email}
              fontFamily={FontNames.sequelSansVFB1}
            />
          }
        />
      ))}
    </S.TopContent>
  );

  const accordionItems = offices
    .filter(o => o.order !== 0)
    .map(({ office }) => ({
      heading: office.heading,
      content: <ContactOfficeCard office={office} />,
    }));

  return (
    <S.Wrapper {...rest}>
      {topContent}
      <Accordion items={accordionItems} />
    </S.Wrapper>
  );
};

MobileOfficesAccordion.defaultProps = defaultProps;

export default MobileOfficesAccordion;
